export const esWrapper = {
  invoke: {
    src: 'setESWrapperLinksToOpenInExternal',
    cond: 'isHybrid888',
  },
};
